// extracted by mini-css-extract-plugin
module.exports = {"switchContainer":"switch_switchContainer___kzZA","handle":"switch_handle__0wm6U","nightMode":"switch_nightMode__MgY3f","lightMode":"switch_lightMode__T9IRN"};